export default {
  title: 'Payment Gateways',
  subtitle: 'Manage payment gateway options',
  createPaymentGateway: 'Create Payment Gateway',
  editPaymentGateway: 'Edit Payment Gateway',
  deletePaymentGateway: 'Delete Payment Gateway',
  addNew: 'Add Payment Gateway',
  breadcrumbs: {
    paymentGateways: 'Payment Gateways',
    create: 'Create',
    edit: 'Edit',
  },
  table: {
    displayOrder: 'Display Order',
    reorder: 'Reorder Payment Gateways',
    name: 'Name',
    isActive: 'Status',
    currencyCode: 'Currency',
    type: 'Type',
    commissionType: 'Commission Type',
    createdAt: 'Created At',
    actions: 'Actions',
  },
  fields: {
    name: 'Name',
    currencyCode: 'Currency',
    displayOrder: 'Display Order',
    isActive: 'Active',
    type: 'Type',
    commissionType: 'Commission Type',
    commissionPercent: 'Commission Percent (%)',
    commissionValue: 'Commission Value',
    logo: 'Logo',
    additionalProperties: 'Additional Properties',
  },
  typeOptions: {
    disabled: 'Disabled',
    enabledWhatsapp: 'Enabled (WhatsApp)',
    enabledOnlinePayment: 'Enabled (Online Payment)',
  },
  commissionTypeOptions: {
    percent: 'Percent',
    value: 'Value',
    percentAndValue: 'Percent and Value',
  },
  placeholders: {
    name: 'Enter payment gateway name',
    currencyCode: 'Select currency',
    displayOrder: 'Leave empty to place it last',
    commissionPercent: 'Enter commission percent',
    commissionValue: 'Enter commission value',
    logo: 'JPG, PNG, GIF, or WebP. Maximum 5 MB.',
    additionalPropertyKey: 'Property key',
    additionalPropertyValue: 'Property value',
  },
  buttons: {
    addProperty: 'Add Property',
  },
  validation: {
    nameRequired: 'Name is required',
    nameMinLength: 'Name must be at least 2 characters',
    nameMaxLength: 'Name must not exceed 100 characters',
    currencyCodeRequired: 'Currency is required',
    displayOrderRange: 'Display order must be a whole number greater than or equal to 0',
    commissionPercentRequired: 'Commission percent is required',
    commissionPercentRange: 'Commission percent must be between 0 and 100',
    commissionValueRequired: 'Commission value is required',
    commissionValueMin: 'Commission value must be greater than or equal to 0',
  },
  messages: {
    fetchError: 'Failed to fetch payment gateways',
    createError: 'Failed to create payment gateway',
    createSuccess: 'Payment gateway created successfully',
    updateError: 'Failed to update payment gateway',
    updateSuccess: 'Payment gateway updated successfully',
    logoUploadError: 'Payment gateway saved, but the logo upload failed',
    deleteError: 'Failed to delete payment gateway',
    deleteSuccess: 'Payment gateway deleted successfully',
    deleteConfirm: 'Are you sure you want to delete this payment gateway?',
    reorderSuccess: 'Payment gateway order updated successfully',
    reorderError: 'Failed to update payment gateway order',
    dragToReorder: 'Drag and drop rows to control the website payment order.',
    reorderSearchDisabled: 'Clear the search field to drag and reorder the full list.',
    reordering: 'Saving payment gateway order...',
    noPaymentGateways: 'No payment gateways found',
  },
};
